import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';
import { AgGridHelper } from '../../../util/AgGridHelper';
import { ShipService } from '../../../service/ship/ship.service';
import { DeliassorterrorService } from '../../../service/deli-assort-error/deli-assort-error.service';
import { DeliassortService } from '../../../service/deli-assort/deli-assort.service';
import { ClientReportService } from '../../../service/client-report/client-report.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { GridButtonRenderComponent } from '../../../render/grid-button-render.component';

@Component({
  selector: 'app-root',
  templateUrl: 'wa3016.component.html',
  styleUrls: ['wa3016.component.scss']
})
export class Wa3016Component implements AfterViewInit {
  private gridApi: any;
  public componentTitle = 'WA3016:出荷指示・配送仕分コード修正';
  public updprogramCd = 'WA3016';

  public gridOptions: GridOptions;
  public assortgridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];
  public assortData: any[];

  public ownerId: number;

  public postCd: string;
  public prefTx: string;
  public townTx: string;
  public config = config;
  private openotherwindow: boolean = false;
  public working = false;
  public containerHeight = 300;
  public cardHeight = 300;
  public gridHeight = 300;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';
  private tabvalue: number = 1;
  private totalCount: number = 0;
  private totalCountwindow: number = 0;
  private selectedRows;
  private isEnableClearFilterButton = false;
  private isEnableClearFilterButton2 = false;
  private selectedCount: number = 0
  private isShowGridNoDataOverlay = false;

  @ViewChild('gridView')
  gridView: ElementRef;
  @ViewChild('gridwindow')
  gridwindow: ElementRef;
  private gridHelper: AgGridHelper;
  private GridHelper: AgGridHelper;

  private isShowSearchNoDataText = false;
  private isDelayHide = false;

  private isOwnerSearchNone = false;
  private paginationGetRowCount = 0;

  constructor(
    private router: Router,
    private shipService: ShipService,
    private deliassorterrorService: DeliassorterrorService,
    private deliassortService: DeliassortService,
    private clientReportService: ClientReportService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    this.gridHelper = new AgGridHelper();
    this.gridHelper.gridSelectionCheckboxStyle = 'radio';
    environment.gridLocale.noRowsToShow = '<p class="nodata">修正が必要なデータはありません。</p>';
    this.gridOptions = <GridOptions>{
      rowSelection: 'single',
      floatingFilter: true,
      enableRangeSelection: false,
      localeText: environment.gridLocale,
      onColumnResized: this.saveColumnWidth,
      pagination: true,
      shohwLoadingOverlay: true,
      suppressRowClickSelection: false,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa3016_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridView.nativeElement.querySelectorAll('div.ag-spread .ag-pinned-left-header .ag-header-cell:first-child .ag-floating-filter-body')[0].style.display = 'block';
        this.gridHelper.onGridReady();
      },
      onPaginationChanged: () => {
        this.totalCount = this.gridOptions.api.paginationGetRowCount();
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();
      },
      onFilterChanged: () => {
        this.isEnableClearFilterButton = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
        this.errorInfo = '';
        this.isShowGridNoDataOverlay = this.gridHelper.isShowGridNoDataOverlay;
      },
      postProcessPopup: params => {
        this.errorInfo = '';
        this.gridHelper.fixedAgMenu();
      }
    };
    this.gridOptions.columnDefs = [
      {
        cellRendererParams: {
          buttonText: '修正',
          itemFieldAfterButton: 'dtpostalCd',
          onClick: this.secondaryButtonClick.bind(this)
        },
        headerName: '郵便番号',
        field: 'dtpostalCd',
        width: this.getColumnWidth('dtpostalCd', 180),
        cellClass: ['bl', 'tl', 'cellclass', 'dtpostalCd'],
        unSortIcon: true,
        pinned: 'left',
        suppressMenu: true,
        cellRendererFramework: GridButtonRenderComponent
      },
      {
        headerName: '住所1',
        field: 'dtaddress1Tx',
        width: this.getColumnWidth('dtaddress1Tx', 300),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '住所2',
        field: 'dtaddress2Tx',
        width: this.getColumnWidth('dtaddress2Tx', 250),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '住所3',
        field: 'dtaddress3Tx',
        width: this.getColumnWidth('dtaddress3Tx', 200),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '配送会社',
        field: 'carrierTx',
        width: this.getColumnWidth('carrierTx', 140),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主ID',
        field: 'ownerId',
        width: this.getColumnWidth('ownerId', 120),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        width: this.getColumnWidth('ownerCd', 120),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '出荷番号',
        field: 'shipnoCd',
        width: this.getColumnWidth('shipnoCd', 160),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '受注番号',
        field: 'ordernoCd',
        width: this.getColumnWidth('ordernoCd', 140),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      }
    ];
    this.gridHelper.setGridOptions(this.gridOptions);

    this.GridHelper = new AgGridHelper();
    this.GridHelper.gridSelectionCheckboxStyle = 'radio';
    environment.gridLocale.noRowsToShow = '<p class="nodata">表示する項目はありません</p>';
    this.assortgridOptions = <GridOptions>{
      rowSelection: 'single',
      floatingFilter: true,
      enableRangeSelection: false,
      localeText: environment.gridLocale,
      pagination: true,
      onColumnResized: this.saveColumnWidth,
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa3017_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.GridHelper.onGridReady();
      },

      onPaginationChanged: () => {
        this.totalCountwindow = this.assortgridOptions.api.paginationGetRowCount();
        this.GridHelper.renderScrollArrow();
        this.GridHelper.renderGridCheckboxImage();
      },

      onFilterChanged: () => {
        this.isEnableClearFilterButton2 = this.assortgridOptions.api.isAnyFilterPresent();
        this.GridHelper.onGridFilterChanged();
        this.errorInfo = '';
        this.isShowGridNoDataOverlay = this.gridHelper.isShowGridNoDataOverlay;
      },
      onRowDataChanged: () => {
        this.errorInfo = '';
        this.GridHelper.onRowDataChanged();

        this.selectedCount = 0;
        if (this.gridOptions.rowData && this.gridOptions.rowData.length > 0) this.GridHelper.isShowGridNoDataOverlay = false;
        else this.GridHelper.isShowGridNoDataOverlay = true;
      },
      onSelectionChanged: () => {
        this.errorInfo = '';
        this.selectedCount = this.assortgridOptions.api.getSelectedRows().length;
      },
      overlayNoRowsTemplate: '&nbsp;'
    };
    this.assortgridOptions.columnDefs = [
      {
        headerName: '',
        field: 'checkbox',
        width: 30,
        checkboxSelection: true,
        suppressMenu: true,
        pinned: 'left',
        cellClass: ['tc', 'cl_w', 'noCellFocus']
      },
      {
        headerName: '郵便番号',
        field: 'postCd',
        width: this.getColumnWidth('ordernoCd', 100),
        unSortIcon: true,
        cellClass: ['tc', 'cellclass']
      },
      {
        headerName: '都道府県名',
        field: 'prefTx',
        width: this.getColumnWidth('ordernoCd', 100),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '市区群町村名',
        field: 'cityTx',
        width: this.getColumnWidth('ordernoCd', 150),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '町域',
        field: 'townTx',
        width: this.getColumnWidth('ordernoCd', 150),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '仕分コード',
        field: 'assortCd',
        width: this.getColumnWidth('ordernoCd', 150),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      }
    ];
    this.GridHelper.setGridOptions(this.assortgridOptions);
    this.GridHelper.gridSelectionCheckboxStyle = 'radio';
    this.assortData = [];
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa3016_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa3016_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa3016_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  onSelectionChanged() {
    this.errorInfo = '';
    if (this.selectedRows.length !== 1) {
      this.resetUserinput();
      return;
    }

    this.postCd = '';
    this.prefTx = this.selectedRows[0].dtprefTx;
    this.townTx = '';
    document.getElementById('postCdInput').focus();
  }

  resetUserinput() {
    this.postCd = '';
    this.prefTx = '';
    this.townTx = '';
    this.assortgridOptions.api.setRowData([]);
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;
    this.GridHelper.el = this.gridwindow;
    setTimeout(() => {
      this.onSubmit();
    }, 500);
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonMargin;
  }

  onSubmit() {
    this.errorInfo = '';
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.gridOptions.api.showLoadingOverlay();
    this.deliassorterrorService
      .get()
      .then(outputJson => {
        setTimeout(() => {
          this.working = false;
          this.gridOptions.api.hideOverlay();
          this.rowData = outputJson.errorList;
        },300);
      })
      .catch(error => {
        this.working = false;
        this.gridOptions.api.hideOverlay();
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onSearchSubmit() {
    this.errorInfo = '';

    if (this.tabvalue == 1) {
      this.townTx = '';
    } else {
      this.postCd = '';
    }

    if (this.townTx.length === 0 && this.postCd.length === 0) {
      this.errorInfo = '郵便番号と町域のいずれかの入力が必要です。';
      return
    }
    this.working = true;

    this.deliassortService
      .get(this.selectedRows.carrierCd, this.postCd, this.selectedRows.dtprefTx, this.townTx)
      .then(outputJson => {
        this.working = false;
        this.assortData = outputJson.assortList;
        console.log(outputJson.assortList);

        if (this.tabvalue == 1) {
          this.isShowSearchNoDataText = this.postCd.length > 0 && this.assortData.length == 0;
        } else {
          this.isShowSearchNoDataText = this.prefTx.length > 0 && this.townTx.length > 0 && this.assortData.length == 0;
        }
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onUpdateSubmit() {
    var selectedRows = this.gridOptions.api.getSelectedRows();
    if (selectedRows.length !== 1) {
      this.errorInfo = '修正対象を選択して下さい';
      return;
    }
    var shiphId = selectedRows[0].shiphId;

    var selectedAssortRows = this.assortgridOptions.api.getSelectedRows();
    if (selectedAssortRows.length !== 1) {
      this.errorInfo = '修正後の郵便番号を選択して下さい';
      return;
    }
    var postCd = selectedAssortRows[0].postCd;
    var duplicatetypeCd = selectedAssortRows[0].duplicatetypeCd;
    var postsubCd = selectedAssortRows[0].postsubCd;
    
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.deliassorterrorService
      .put(shiphId, postCd, duplicatetypeCd, postsubCd, 'WA3016')
      .then(outputJson => {
        this.working = false;
        this.gridOptions.api.updateRowData({ remove: selectedRows });
        this.resetUserinput();
        this.close();
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onFilterClear() {
    this.errorInfo = '';
    this.gridOptions.api.setFilterModel(null);
  }

  filterClearAndSubmit() {
    this.errorInfo = '';
    this.assortgridOptions.api.setFilterModel(null);
  }

  secondaryButtonClick(node) {
    sessionStorage.setItem('isOwnerDisable', 'true');
    this.postCd = '';
    this.townTx = '';
    this.selectedCount = 0;
    var rowIndex = node.id;
    this.selectedRows = this.rowData[rowIndex];
    this.prefTx = this.selectedRows.dtprefTx;

    if (this.openotherwindow === false) {
      this.openotherwindow = true;
      this.isDelayHide = false;
    }
  }

  close() {
    this.errorInfo = '';
    sessionStorage.removeItem('isOwnerDisable');
    this.openotherwindow = false;
    setTimeout(() => {
      this.isDelayHide = true;
    }, 300);
  }

  tabs(node) {
    this.tabvalue = node;
  }
  changeOwner(selectedOwnerId) {
    console.log(selectedOwnerId);
    if (selectedOwnerId !== null) {
      if (selectedOwnerId !== undefined) {
        this.ownerId = selectedOwnerId;
      } else {
        this.ownerId = undefined;
      }
      this.onSubmit();
    } else {
      this.rowData = [];

      this.gridOptions.api.deselectAll();
    }
  }

  inputChanged(ownerId: string) {
    if (ownerId == null) this.isOwnerSearchNone = true;
    else this.isOwnerSearchNone = false;
    this.changeOwner(ownerId);
  }

  ownerInputChanged(ownerId: string) {
    if (ownerId == null && ownerId !== undefined) this.gridHelper.isOwnerNotFound = true;
    else this.gridHelper.isOwnerNotFound = false;
    this.changeOwner(ownerId);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa3Shipment/wa3016/wa3016.component.ts